import React, { Component } from "react";
import PropTypes from "prop-types";
import { Popover, PopoverBody, UncontrolledPopover } from "reactstrap";
import uuid from "uuid";

import "./Participents.less";

import { getMessage } from "CONFIG/i18n";
import { getUserNameAcronym } from "UTILS/Utility";

export default class ParticipantsList extends Component {
  static propTypes = {
    participants: PropTypes.array,
    isOpen: PropTypes.bool,
    popoverTarget: PropTypes.string
  };
  state = {
    participantId: null
  };
  onFrameOrInkLockClick = (uniqueId) => {
    if (this.props.popoverOpenInkLock) {
      this.props.onFrameOrInkLockClick(uniqueId);
    } else {
      let isFrameActiveFlag = this.props.frameLockedParticipantId === uniqueId;
      this.props.onFrameOrInkLockClick(uniqueId, !isFrameActiveFlag);
    }
  };

  renderParticipants = () => {
    return (
      <UncontrolledPopover
        placement="top"
        isOpen={this.props.isOpen}
        target={this.props.popoverTarget}
        toggle={() => this.props.togglePopOver()}
        trigger="legacy"
      >
        <PopoverBody>
          {this.props.participants.map(participant => {
            if (this.props.organiser !== participant.uniqueId)
              return (
                <div
                  key={uuid.v4()}
                  className={
                    this.props.popoverOpenInkLock
                      ? this.props.inkUnLockedParticipants.indexOf(
                        participant.uniqueId
                      ) !== -1
                        ? "  participant cursorPointer"
                        : "   participant cursorPointer labelActive "
                      : 
                      // (participant.participantId ===
                      //     this.state.participantId ||
                      this.props.frameLockedParticipantId === 
                          participant.uniqueId
                        ? " participant cursorPointer labelActive  "
                        : "  participant cursorPointer "
                  }
                  id={participant.uniqueId}
                  onClick={() =>
                    this.onFrameOrInkLockClick(
                      participant.uniqueId
                    )
                  }
                  title={participant.userName}
                >
                  <label>
                    {getUserNameAcronym(participant.userName)}
                  </label>
                </div>
              );
          })}
        </PopoverBody>
      </UncontrolledPopover>
    );
  };
  render() {
    return <div className="participantList">{this.renderParticipants()}</div>;
  }
}
